export default [
    {
        path: '/peifu',
        name: 'peifu',
        component: () => import('@/views/peifu/index'),
        redirect:"/peifu/dengjipeifu",
        children:[
            {
                path: '/peifu/dengjipeifu',
                name: 'dengjipeifu',
                component: () => import('@/views/peifu/dengjipeifu')
            },
            {
                path: '/peifu/peifushangpin',
                name: 'peifushangpin',
                component: () => import('@/views/peifu/peifushangpin')
            },
            {
                path: '/peifu/shouhourenyuan',
                name: 'shouhourenyuan',
                component: () => import('@/views/peifu/shouhourenyuan')
            },
            {
                path: '/peifu/peifudaoru',
                name: 'peifudaoru',
                component: () => import('@/views/peifu/peifudaoru')
            },
            {
                path: '/peifu/peifudaochu',
                name: 'peifudaochu',
                component: () => import('@/views/peifu/peifudaochu')
            },
        
      ]
    },
  ]
  


// WEBPACK FOOTER //
// ./src/router/peifu.js